import React from "react";
import { WhatsAppShareConfirmModal } from "../../whatsappShareModalShared";

interface InvoiceShareModalProps {
  invoice: any;
  onClose: () => void;
  onShareOfficial: () => Promise<void>;
  loading?: boolean;
}

const InvoiceShareModal: React.FC<InvoiceShareModalProps> = ({
  invoice,
  onClose,
  onShareOfficial,
  loading = false,
}) => {
  return (
    <WhatsAppShareConfirmModal
      title="Share Invoice"
      customerName={invoice?.customer_name || invoice?.customer?.name || ""}
      customerPhone={invoice?.customer_phone || invoice?.customer?.phone || ""}
      documentNumber={invoice?.invoice_no || ""}
      grandTotal={invoice?.grand_total || invoice?.total || 0}
      pdfFileName={`Invoice_${invoice?.invoice_no || "detail"}.pdf`}
      onClose={onClose}
      onConfirm={onShareOfficial}
      loading={loading}
    />
  );
};

export default InvoiceShareModal;
